import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import ViewerDocument from '../../../../../../shared/components/ViewerDocument'
import { useAlert } from '../../../../../../shared/components/Alert'
import useMultiCalculoClient from '../../../../../../clients/MultiCalculoClient/useMulticalculoClient'
import { DOCUMENT_TYPE } from '../../../../../../shared/constants/MultiCalculo'

const MinutaViewer = () => {
  const multiCalculoClient = useMultiCalculoClient()
  const { proposalUniqueId } = useParams()
  const { insuranceUniqueId } = useParams()
  const { addMsgDanger } = useAlert()
  const navigate = useNavigate()
  const [draftData, setDocumentData] = useState('')

  useEffect(() => {
    if (!proposalUniqueId) {
      addMsgDanger({
        title: 'Documento indisponível',
        message: 'Identificador da proposta não informado.',
        action: () => navigate('/multicalculo/judicial-deposito-recursal'),
      })
      return
    }

    multiCalculoClient()
      .downloadDocumentByInsurance({
        proposalUniqueId,
        insuranceUniqueId,
        documentType: DOCUMENT_TYPE.DRAFT,
      })
      .then((response) => {
        setDocumentData(response?.data ?? response)
      })
      .catch(() => {
        addMsgDanger({
          title: 'Não foi possível carregar a minuta.',
          message: 'Tente novamente mais tarde ou contate o suporte.',
          action: () => navigate('/multicalculo/judicial-deposito-recursal'),
        })
      })
  }, [proposalUniqueId, insuranceUniqueId, multiCalculoClient, addMsgDanger, navigate])

  if (!draftData) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <Typography variant="body1">Carregando minuta…</Typography>
      </Box>
    )
  }

  return <ViewerDocument documentBase64={draftData} />
}

export default MinutaViewer
